export const EMAIL_REGEX = /^.+@(\w+(-?\w+)+\.)+[a-z]{2,}$/;
export const SPECIAL_CHAR_REGEX = /[!@#$%\\/|?'";:\][}{^&*)(`~+=.,><_-]/;
export const PROPERGATE_URL_REGEX = /\b(\w*propergate.co*)/gi;
export const DATE_PREVIEW_REGEX = /\d{4}-\d{2}-\d{2}/;
export const HOURS_MINUTES_REGEX = /\d{2}:\d{2}$/;
